export enum AnalyticsServiceTypes {
  GOOGLE = 'GOOGLE',
  NONE = 'NONE'
}

export enum AnalyticsEvents {
  LOAD_TRACKING_TRIP_CHANGED= 'load_tracking_trip_changed',
  LOAD_TRACKING_TRIP_REMAINING_DISTANCE= 'load_tracking_trip_remaining_distance',
  PAGE_VIEW = 'pageview'
}

export interface AnalyticsConfiguration {
  type: AnalyticsServiceTypes
}

export abstract class AnalyticsService {

  abstract createEvent(key: AnalyticsEvents, params: { }): void

}
